<elcia-card>
  <div class="flex h-full min-w-0 flex-col gap-3">

  <div class="flex min-w-0 flex-wrap items-center justify-between gap-2">
    <div class="flex min-w-0 items-center gap-2.5">
      <span aria-hidden="true" class="pi pi-chart-pie flex-none text-sm text-[var(--p-surface-400)]"></span>
      <span class="min-w-0 text-lg font-bold">{{ 'dashboard.breakdown.title' | translate }}</span>
    </div>

    <div class="flex items-center gap-1" role="tablist">
      <button (click)="setTab('customer')"
              [attr.aria-selected]="tab() === 'customer'"
              [class]="tabClass('customer')"
              class="cursor-pointer border-b-2 px-3 py-1.5 text-sm transition-colors"
              role="tab"
              type="button">
        {{ 'dashboard.breakdown.by-customer' | translate }}
      </button>
      <button (click)="setTab('type')"
              [attr.aria-selected]="tab() === 'type'"
              [class]="tabClass('type')"
              class="cursor-pointer border-b-2 px-3 py-1.5 text-sm transition-colors"
              role="tab"
              type="button">
        {{ 'dashboard.breakdown.by-type' | translate }}
      </button>
    </div>
  </div>

  @if (isLoading()) {
    <div class="flex flex-1 items-center justify-center">
      <elcia-loader/>
    </div>
  } @else if (!hasData()) {
    <div class="flex flex-1 items-center justify-center text-sm text-[var(--p-surface-500)]">
      {{ 'dashboard.breakdown.empty' | translate }}
    </div>
  } @else {
    <div class="min-h-0 flex-1">
      <p-chart [data]="data()" [options]="options()" height="100%" type="bar"/>
    </div>
  }
  </div>
</elcia-card>
